import * as React from 'react';
import { Link } from 'react-router-dom';
import Page from '../../components/Page';
import Loader from '../../components/Loader';
import { ErrorFlash, WarningFlash } from '../../components/Flash';
import { classes } from '../../components/Button';
import { ProfileContext, ProfileManager } from '../../profile';
import { useRequest, getHeaders } from '../../api/client';
import ProductsList from '../../components/ProductsList';

const products = (context: ProfileManager) => {
  const [state, _] = useRequest(() => ({
    url: '/store/products',
    method: 'GET',
    headers: getHeaders(context),
  }));

  return state;
};

const newProduct = (context: ProfileManager): any => ({
  available: true,
  available_from: null,
  available_in: [],
  available_worldwide: true,
  categories: [],
  category_ids: [],
  company_id: context.profile.company_id,
  company: context.profile.company,
  description_text: '',
  details: [],
  id: null,
  image_url: null,
  images: [],
  name: '',
  public_url: null,
  tags: [],
  theme: context.profile.company.theme,
  variants: [],
});

export default function Products() {
  const context = React.useContext(ProfileContext);
  const state = products(context);

  if (state.loading) {
    return <Loader />;
  }

  return (
    <Page title="Products" subtitle="Manage your product offering in Filtru">
      {state.error && <ErrorFlash error={state.error} />}
      {!context.profile.company.contract_id && (
        <WarningFlash
          text="Products will not be published until you provide billing information"
        />
      )}
      <div className="flex justify-center ml-auto mr-auto">
        <Link
          to={{
            pathname: '/products/new',
            state: {
              product: newProduct(context),
            },
          }}
          className={`${classes} dib ml-auto mr-auto`}
        >
          Create new
        </Link>
      </div>
      <ProductsList items={state.data || []} />
    </Page>
  );
}
